import React, { useEffect, useMemo } from 'react';
import { InputGroup, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from "@fortawesome/free-solid-svg-icons";

function ReasonFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    const { t } = useTranslation();

    // Calculate the options for filtering using the preFilteredRows
    const options = useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach(row => {
            if (row.values[id]) {
                options.add(row.values[id]);
            }
        });
        return [...options.values()];
    }, [id, preFilteredRows]);

    const allOptions = useMemo(() => {
        return { name: "allNoDebug", value: [...new Set(preFilteredRows.map(o => o.values.reason).filter(r => r !== "Debug"))].toString() };
    }, [preFilteredRows]);

    const allWithDebugOptions = useMemo(() => {
        return { name: "all", value: null };
    }, []);

    const anyReasonWithDebugOptions = useMemo(() => {
        return { name: "anyReason", value: [...new Set(preFilteredRows.map(o => o.values.reason).filter(r => r !== "" && r !== null))].toString() };
    }, [preFilteredRows]);

    const anyReasonOptions = useMemo(() => {
        return { name: "anyReasonNoDebug", value: [...new Set(preFilteredRows.map(o => o.values.reason).filter(r => r !== "" && r !== null && r !== "Debug"))].toString() };
    }, [preFilteredRows]);

    useEffect(() => {
        setFilter(JSON.stringify(allOptions));
    }, [allOptions]); // Cannot add SetFilter to dependency array as it changes when an new option is select, returning this component to it's intial state

    return (
        <InputGroup>
            <InputGroup.Text><FontAwesomeIcon icon={faFilter} /></InputGroup.Text>
            <Form.Select
                id="commentReasonFilter"
                size="sm"
                value={filterValue}
                onChange={e => {
                    setFilter(e.target.value);
                }}>
                <option key="0" id="all" value={JSON.stringify(allOptions)}>{t("LotDetails.Comments.Filters.All")}</option>
                <option key="1" id="allWithDebug" value={JSON.stringify(allWithDebugOptions)}>{t("LotDetails.Comments.Filters.AllWithDebug")}</option>
                <option key="2" id="anyReason" value={JSON.stringify(anyReasonOptions)}>{t("LotDetails.Comments.Filters.AnyReason")}</option>
                <option key="3" id="anyReasonWithDebug" value={JSON.stringify(anyReasonWithDebugOptions)}>{t("LotDetails.Comments.Filters.AnyReasonWithDebug")}</option>
                {options.map((option, i) => (

                    <option key={i + 4} value={JSON.stringify({ name: option, value: option })}>
                        {option}
                    </option>
                ))}
            </Form.Select>
        </InputGroup>
    );
}

export default ReasonFilter;
